import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  TextArea,
  Checkbox,
  Button,
  Radio,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardAdverseReactionNoteUX = (props: any) => {
    return(
      <div
        className="card-adverse-reaction-note"
        id="CardAdverseReactionNoteUX-div-0">
        <div
          className="card-title"
          id="CardAdverseReactionNoteUX-div-1">

          <div
            id="CardAdverseReactionNoteUX-div-7">
            {props.adrSelected !== "new" ? "แก้ไขรายละเอียดอาการไม่พึ่งประสงค์จากการใช้ยา" : "บันทึกรายละเอียดอาการไม่พึ่งประสงค์จากการใช้ยา"}
          </div>
        </div>
        <div
          id="CardAdverseReactionNoteUX-div-2">
          {props.menu}
        </div>
        <div
          id="CardAdverseReactionNoteUX-div-46"
          style={{height: "25px", width: "100%"}}>

        </div>
        <div
          id="CardAdverseReactionNoteUX-div-48"
          style={{display: props.drugForm? "flex": "none", width: "100%", padding: "20px"}}>

          <div
            className="ui form"
            id="CardAdverseReactionNoteUX-div-50"
            style={{width: "75%"}}>

            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-51"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-59"
                inline={true}
                width={2}>
                <div
                  className="field-title red"
                  id="CardAdverseReactionNoteUX-div-74"
                  style={{color:"red"}}>
                  {props.languageUX === "en" ? "Allergens*" : "สารก่อการแพ้*"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-60"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-75"
                  style={{width: "100%"}}>
                  {props.searchAdversary}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-52"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-61"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-76">
                  {props.languageUX === "en" ? "Allergic symptoms" : "อาการแพ้"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-62"
                inline={true}
                width={6}>
                <div
                  id="CardAdverseReactionNoteUX-div-77"
                  style={{width: "100%"}}>

                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardAdverseReactionNote-Dropdown-Symptoms"
                    multiple={true}
                    name="symptoms"
                    onChange={props.onChangeADR}
                    options={props.adrSymptomsOptions}
                    search={true}
                    selection={true}
                    value={props.symptoms}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-194"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-196">
                  {props.languageUX === "en" ? "Date of symptom onset" : "วันที่มีอาการ"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-195"
                inline={true}
                width={5}>
                <DateTextBox
                  id="CardAdverseReactionNote-DateTextBox-SymptomsDate"
                  onChange={props.onChangeDateSymptoms}
                  style={{ width: "100%" }}
                  value={props.dateSymptoms}>
                </DateTextBox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-198"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-199"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-201">
                  {props.languageUX === "en" ? "Specify other allergic symptoms" : "ระบุอาการแพ้อื่นๆ"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-200"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-202"
                  style={{width: "100%"}}>

                  <Input
                    id="CardAdverseReactionNote-Input-OtherSymptoms"
                    name="other_symptom"
                    onChange={props.onChangeADR}
                    value={props.AllergySequence?.adrSelected?.other_symptom}>
                  </Input>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-53"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-63"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-79"
                  style={{color:"red"}}>
                  {props.languageUX === "en" ? "type*" : "ประเภท*"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-64"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-80"
                  style={{width: "100%"}}>

                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardAdverseReactionNote-Dropdown-AffectType"
                    name="adversary_symptom_type"
                    onChange={props.onChangeADR}
                    options={props.affectTypeOptions}
                    search={true}
                    selection={true}
                    value={props.affectType}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-54"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-65"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-82">
                  {props.languageUX === "en" ? "Violence" : "ความรุนแรง"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-66"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-90"
                  style={{width: "100%"}}>

                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardAdverseReactionNote-Dropdown-Severity"
                    name="severity"
                    onChange={props.onChangeADR}
                    options={props.adrSeverityOptions}
                    search={true}
                    selection={true}
                    value={props.severity}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-56"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-69"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-88">
                  {props.languageUX === "en" ? "Possibility" : "ความเป็นไปได้"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-70"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-95"
                  style={{display: "flex", alignItems: "center", width: "100%"}}>

                  <Checkbox
                    checked={props.naranjoChecked}
                    id="CardAdverseReactionNote-Checkbox-NaranjoChecked"
                    onChange={props.onChangeNaranjoChecked}
                    style={{marginRight: "8px"}}>
                  </Checkbox>
                  <Button
                    color="blue"
                    disabled={props.AllergySequence?.adrSelected?.naranjoChecked !== true}
                    id="CardAdverseReactionNote-Button-Naranjo"
                    onClick={props.onClickNaranjo}
                    style={{minWidth: "max-content", paddingLeft: "0.7rem", paddingRight: "0.7rem"}}>
                    {props.languageUX === "en" ? "Naranjo Score" : "คะแนนนารันโจ"}
                  </Button>
                  <Input
                    disabled={true}
                    fluid={true}
                    id="CardAdverseReactionNote-Input-NaranjoScore"
                    readOnly={true}
                    style={{width: "100%", padding: "0 0.5rem", opacity: "1",}}
                    value={props.AllergySequence.adrSelected?.naranjo_data?.score !== undefined ?  props.AllergySequence.adrSelected?.naranjo_data?.score : ""}>
                  </Input>
                  <Dropdown
                    clearable={true}
                    disabled={props.naranjoChecked}
                    fluid={true}
                    id="CardAdverseReactionNote-Dropdown-Probability"
                    name="probability"
                    onChange={props.onChangeADR}
                    options={props.adrProbabilityOptions}
                    search={true}
                    selection={true}
                    value={props.probability}>
                  </Dropdown>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-55"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-67"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-92"
                  style={{color:"red"}}>
                  {props.languageUX === "en" ? "Notification message*" : "ข้อความแจ้งเตือน*"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-68"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-93"
                  style={{width: "100%"}}>

                  <TextArea
                    id="CardAdverseReactionNote-TextArea-Note"
                    name="note"
                    onChange={props.onChangeADR}
                    value={props.note}>
                  </TextArea>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-57"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-72"
                inline={true}
                width={2}>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-98"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-101"
                  style={{display: "flex", justifyContent: "flex-end", alignItems: "Center", width: "100%"}}>

                  <Button
                    color="green"
                    id="CardAdverseReactionNote-Button-SaveAdr"
                    onClick={props.onSaveNewADRNote}
                    style={{marginRight: "10px"}}>
                    {props.languageUX === "en" ? "record" : "บันทึก"}
                  </Button>
                  <Button
                    color="red"
                    id="CardAdverseReactionNote-Button-CancelAdr"
                    onClick={props.onCancelNewADRNote}>
                    {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardAdverseReactionNoteUX-div-58"
            style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

            <div
              id="CardAdverseReactionNoteUX-div-104"
              style={{display: "flex", flexDirection:"column", width: "100%", height: "100%", alignItems: "center"}}>

              <div
                id="CardAdverseReactionNoteUX-div-105"
                style={{paddingLeft: "10px",display: props.showPharma}}>
                {props.languageUX === "en" ? "For pharmacists" : "สำหรับเภสัชกร"}
              </div>
              <div
                id="CardAdverseReactionNoteUX-div-106"
                style={{display: props.typePharma, flexDirection: "column", padding: "10px", backgroundColor: "#e8f5fd", borderRadius: "5px", height: "170px", justifyContent: "space-between"}}>

                <div
                  id="CardAdverseReactionNoteUX-div-107">

                  <Radio
                    checked={props.pharmacyAction === "NOTED"}
                    id="CardAdverseReactionNote-Radio-AdrNoted"
                    label={props.languageUX === "en" ? "NOTE" : "บันทึก"}
                    onChange={props.onChangePharmacyAction}
                    value="NOTED">
                  </Radio>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-108">

                  <Radio
                    checked={props.pharmacyAction === "VERIFIED"}
                    id="CardAdverseReactionNote-Radio-AdrVerify"
                    label={props.languageUX === "en" ? "VERIFY (prescription available)" : "VERIFY (สั่งยาได้)"}
                    onChange={props.onChangePharmacyAction}
                    value="VERIFIED">
                  </Radio>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-109">

                  <Radio
                    checked={props.pharmacyAction === "LOCKED"}
                    id="CardAdverseReactionNote-Radio-AdrLocked"
                    label={props.languageUX === "en" ? "VERIFY & LOCK (Do not order drugs)" : "VERIFY & LOCK (ห้ามสั่งยา)"}
                    onChange={props.onChangePharmacyAction}
                    value="LOCKED">
                  </Radio>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-110"
                  style={{display: "flex"}}>

                  <Checkbox
                    checked={props.adrActive}
                    id="CardAdverseReactionNoteUX-Checkbox-205"
                    label={props.adrActive ? "Active" : "INACTIVE"}
                    onChange={props.onChangePharmacyAction}
                    toggle={true}>
                  </Checkbox>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-147">

                  <div
                    id="CardAdverseReactionNoteUX-div-149"
                    style={{width: "100%"}}>
                    {props.inactiveDate}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardAdverseReactionNoteUX-div-49"
          style={{display: props.otherForm? "flex": "none", width: "100%", padding: "20px"}}>

          <div
            className="ui form"
            id="CardAdverseReactionNoteUX-div-116"
            style={{width: "75%"}}>

            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-117"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-118"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-119"
                  style={{color:"red"}}>
                  {props.languageUX === "en" ? "details*" : "รายละเอียด*"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-120"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-121"
                  style={{width: "100%"}}>

                  <TextArea
                    id="CardAdverseReactionNote-TextArea-OtherAdversary"
                    name="name"
                    onChange={props.onChangeADR}
                    value={props.adversaryText}>
                  </TextArea>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-123"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-124"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-125"
                  style={{color:"red"}}>
                  {props.languageUX === "en" ? "Allergic symptoms*" : "อาการแพ้*"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-126"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-127"
                  style={{width: "100%"}}>

                  <TextArea
                    id="CardAdverseReactionNote-TextArea-OtherSymtoms"
                    name="note"
                    onChange={props.onChangeADR}
                    value={props.note}>
                  </TextArea>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-137"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-138"
                inline={true}
                width={2}>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-139"
                width={3}>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-141"
                inline={true}
                width={10}>
                <div
                  id="CardAdverseReactionNoteUX-div-142"
                  style={{display: "flex", justifyContent: "flex-end", alignItems: "Center", width: "100%"}}>

                  <Button
                    color="green"
                    id="CardAdverseReactionNote-Button-SaveOther"
                    onClick={props.onSaveNewADRNote}
                    style={{marginRight: "10px"}}>
                    {props.languageUX === "en" ? "record" : "บันทึก"}
                  </Button>
                  <Button
                    color="red"
                    id="CardAdverseReactionNote-Button-CancelOther"
                    onClick={props.onCancelNewADRNote}>
                    {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardAdverseReactionNoteUX-div-150"
          style={{display: props.drugFreeText? "flex": "none", width: "100%", padding: "20px"}}>

          <div
            className="ui form"
            id="CardAdverseReactionNoteUX-div-152"
            style={{width: "75%"}}>

            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-156"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-158"
                inline={true}
                width={2}>
                <div
                  className="field-title"
                  id="CardAdverseReactionNoteUX-div-162"
                  style={{color:"red"}}>
                  {props.languageUX === "en" ? "Details of drug allergy*" : "รายละเอียดการแพ้ยา*"}
                </div>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-159"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-163"
                  style={{width: "100%"}}>

                  <TextArea
                    id="CardAdverseReactionNote-TextArea-AdrFreeText"
                    name="note"
                    onChange={props.onChangeADR}
                    value={props.note}>
                  </TextArea>
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAdverseReactionNoteUX-FormGroup-157"
              inline={true}>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-160"
                inline={true}
                width={2}>
              </FormField>
              <FormField
                id="CardAdverseReactionNoteUX-FormField-161"
                inline={true}
                width={13}>
                <div
                  id="CardAdverseReactionNoteUX-div-164"
                  style={{display: "flex", justifyContent: "flex-end", alignItems: "Center", width: "100%"}}>

                  <Button
                    color="green"
                    id="CardAdverseReactionNote-Button-SaveFreeText"
                    onClick={props.onSaveNewADRNote}
                    style={{marginRight: "10px"}}>
                    {props.languageUX === "en" ? "record" : "บันทึก"}
                  </Button>
                  <Button
                    color="red"
                    id="CardAdverseReactionNote-Button-CancelFreeText"
                    onClick={props.onCancelNewADRNote}>
                    {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
                  </Button>
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardAdverseReactionNoteUX-div-168"
            style={{display: "flex", alignItems: "center", justifyContent: "center"}}>

            <div
              id="CardAdverseReactionNoteUX-div-169"
              style={{display: "flex", flexDirection:"column", width: "100%", height: "100%", alignItems: "center"}}>

              <div
                id="CardAdverseReactionNoteUX-div-170"
                style={{paddingLeft: "10px",display: props.showPharma}}>
                {props.languageUX === "en" ? "For pharmacists" : "สำหรับเภสัชกร"}
              </div>
              <div
                id="CardAdverseReactionNoteUX-div-171"
                style={{display: props.typePharma, flexDirection: "column", padding: "10px", backgroundColor: "#e8f5fd", borderRadius: "5px", height: "170px", justifyContent: "space-between"}}>

                <div
                  id="CardAdverseReactionNoteUX-div-172">

                  <Radio
                    checked={props.pharmacyAction === "NOTED"}
                    id="CardAdverseReactionNote-Radio-FreeTextNoted"
                    label={props.languageUX === "en" ? "NOTE" : "บันทึก"}
                    onChange={props.onChangePharmacyAction}
                    value="NOTED">
                  </Radio>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-173">

                  <Radio
                    checked={["VERIFIED", "PAUSED"].includes(props.pharmacyAction)}
                    id="CardAdverseReactionNote-Radio-FreeTextVerify"
                    label={props.languageUX === "en" ? "VERIFY (prescription available)" : "VERIFY (สั่งยาได้)"}
                    onChange={props.onChangePharmacyAction}
                    value="VERIFIED">
                  </Radio>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-174">

                  <Radio
                    checked={props.pharmacyAction === "LOCKED"}
                    id="CardAdverseReactionNote-Radio-FreeTextLocked"
                    label={props.languageUX === "en" ? "VERIFY & LOCK (Do not order drugs)" : "VERIFY & LOCK (ห้ามสั่งยา)"}
                    onChange={props.onChangePharmacyAction}
                    value="LOCKED">
                  </Radio>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-175">

                  <Checkbox
                    checked={props.adrActive}
                    id="CardAdverseReactionNoteUX-Checkbox-206"
                    label={props.adrActive ? "Active" : "INACTIVE"}
                    onChange={props.onChangePharmacyAction}
                    toggle={true}>
                  </Checkbox>
                </div>
                <div
                  id="CardAdverseReactionNoteUX-div-176">

                  <div
                    id="CardAdverseReactionNoteUX-div-177"
                    style={{width: "100%"}}>
                    {props.inactiveDate}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardAdverseReactionNoteUX-div-154"
          style={{display: props.groupForm ?  "": "none", width: "100%", padding: "0px 20px 20px"}}>

          <div
            id="CardAdverseReactionNoteUX-div-184"
            style={{display: "flex", width: "100%" }}>

            <div
              id="CardAdverseReactionNoteUX-div-185"
              style={{ width: "50%", marginRight: "20px", }}>

              <div
                id="CardAdverseReactionNoteUX-div-187"
                style={{ margin: "0px 20px 10px" }}>
                {props.languageUX === "en" ? "--Choose from the drug--" : "--เลือกจากตัวยา--"}
              </div>
              <div
                id="CardAdverseReactionNoteUX-div-190"
                style={{backgroundColor: "rgba(217, 217, 217, 0.46)", overflowY: "auto", height: "450px", }}>
                {props.ingredientList}
              </div>
            </div>
            <div
              id="CardAdverseReactionNoteUX-div-186"
              style={{ width: "50%", marginLeft: "20px", }}>

              <div
                id="CardAdverseReactionNoteUX-div-188"
                style={{ margin: "0px 20px 10px" }}>
                {props.languageUX === "en" ? "--Select from drug group--" : "--เลือกจากกลุ่มยา--"}
              </div>
              <div
                id="CardAdverseReactionNoteUX-div-189"
                style={{backgroundColor: "rgba(217, 217, 217, 0.46)", overflowY: "auto", height: "450px", }}>
                {props.drugGroupList}
              </div>
            </div>
          </div>
          <div
            id="CardAdverseReactionNoteUX-div-191"
            style={{display: "flex", justifyContent: "flex-end", alignItems: "Center", width: "100%", margin: "20px 0px", }}>

            <Button
              color="green"
              id="CardAdverseReactionNote-Button-SaveCommonAdrNote"
              onClick={props.onSaveCommonADRNote}
              style={{ marginRight: "10px" }}>
              {props.languageUX === "en" ? "record" : "บันทึก"}
            </Button>
            <Button
              color="red"
              id="CardAdverseReactionNote-Button-CancelCommonAdrNote"
              onClick={props.onCancelNewADRNote}>
              {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
            </Button>
          </div>
        </div>
        <div
          id="CardAdverseReactionNoteUX-div-155">
          {props.modalNaranjo}
        </div>
      </div>
    )
}


export default CardAdverseReactionNoteUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 17:32:30 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "card-adverse-reaction-note"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-0"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "card-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.menu"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.adrSelected !== \"new\" ? \"แก้ไขรายละเอียดอาการไม่พึ่งประสงค์จากการใช้ยา\" : \"บันทึกรายละเอียดอาการไม่พึ่งประสงค์จากการใช้ยา\""
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{height: \"25px\", width: \"100%\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{display: props.drugForm? \"flex\": \"none\", width: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{display: props.otherForm? \"flex\": \"none\", width: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{width: \"75%\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-56"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"center\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-61"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-62"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-63"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-65"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 54,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 56,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-72"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "สารก่อการแพ้*",
          "valueEN": "Allergens*"
        },
        "className": {
          "type": "value",
          "value": "field-title red"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 60,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchAdversary"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "อาการแพ้",
          "valueEN": "Allergic symptoms"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-76"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Dropdown",
      "parent": 77,
      "props": {
        "allowAdditions": {
          "type": "value",
          "value": ""
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Dropdown-Symptoms"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "symptoms"
        },
        "onAddItem": {
          "type": "code",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "options": {
          "type": "code",
          "value": "props.adrSymptomsOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.symptoms"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภท*",
          "valueEN": "type*"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "Dropdown",
      "parent": 80,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Dropdown-AffectType"
        },
        "name": {
          "type": "value",
          "value": "adversary_symptom_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "options": {
          "type": "code",
          "value": "props.affectTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.affectType"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": "ความรุนแรง",
          "valueEN": "Violence"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-82"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเป็นไปได้",
          "valueEN": "Possibility"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-88"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "Dropdown",
      "parent": 90,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Dropdown-Severity"
        },
        "name": {
          "type": "value",
          "value": "severity"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "options": {
          "type": "code",
          "value": "props.adrSeverityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.severity"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อความแจ้งเตือน*",
          "valueEN": "Notification message*"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "TextArea",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-TextArea-Note"
        },
        "name": {
          "type": "value",
          "value": "note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "rows": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 94,
      "void": true
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Checkbox",
      "parent": 95,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.naranjoChecked"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Checkbox-NaranjoChecked"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeNaranjoChecked"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"8px\"}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Button",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "คะแนนนารันโจ",
          "valueEN": "Naranjo Score"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.AllergySequence?.adrSelected?.naranjoChecked !== true"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-Naranjo"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickNaranjo"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", paddingLeft: \"0.7rem\", paddingRight: \"0.7rem\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-101"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", alignItems: \"Center\", width: \"100%\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Button",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-SaveAdr"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveNewADRNote"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Button",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-CancelAdr"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelNewADRNote"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection:\"column\", width: \"100%\", height: \"100%\", alignItems: \"center\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "สำหรับเภสัชกร",
          "valueEN": "For pharmacists"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\",display: props.showPharma}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{display: props.typePharma, flexDirection: \"column\", padding: \"10px\", backgroundColor: \"#e8f5fd\", borderRadius: \"5px\", height: \"170px\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-107"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-108"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-109"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Radio",
      "parent": 107,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.pharmacyAction === \"NOTED\""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Radio-AdrNoted"
        },
        "label": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "NOTE"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "value": {
          "type": "value",
          "value": "NOTED"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Radio",
      "parent": 108,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.pharmacyAction === \"VERIFIED\""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Radio-AdrVerify"
        },
        "label": {
          "type": "value",
          "value": "VERIFY (สั่งยาได้)",
          "valueEN": "VERIFY (prescription available)"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "toggle": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "value",
          "value": "VERIFIED"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Radio",
      "parent": 109,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.pharmacyAction === \"LOCKED\""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Radio-AdrLocked"
        },
        "label": {
          "type": "value",
          "value": "VERIFY & LOCK (ห้ามสั่งยา)",
          "valueEN": "VERIFY & LOCK (Do not order drugs)"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "value": {
          "type": "value",
          "value": "LOCKED"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-116"
        },
        "style": {
          "type": "code",
          "value": "{width: \"75%\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormGroup",
      "parent": 116,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-117"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 117,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียด*",
          "valueEN": "details*"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 117,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-120"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "TextArea",
      "parent": 121,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-TextArea-OtherAdversary"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "rows": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.adversaryText"
        }
      },
      "seq": 122,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormGroup",
      "parent": 116,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-123"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 123,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-124"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": "อาการแพ้*",
          "valueEN": "Allergic symptoms*"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "FormField",
      "parent": 123,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-126"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "TextArea",
      "parent": 127,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-TextArea-OtherSymtoms"
        },
        "name": {
          "type": "value",
          "value": "note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "rows": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 128,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormGroup",
      "parent": 116,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 137,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormField",
      "parent": 137,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-139"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 137,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", alignItems: \"Center\", width: \"100%\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Button",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-SaveOther"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveNewADRNote"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Button",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-CancelOther"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelNewADRNote"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "Dropdown",
      "parent": 95,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.naranjoChecked"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Dropdown-Probability"
        },
        "name": {
          "type": "value",
          "value": "probability"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "options": {
          "type": "code",
          "value": "props.adrProbabilityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.probability"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-147"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 147,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inactiveDate"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{display: props.drugFreeText? \"flex\": \"none\", width: \"100%\", padding: \"20px\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{width: \"75%\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 153,
      "props": {
        "children": {
          "type": "value",
          "value": "ดิฟ",
          "valueEN": "div"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-153"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{display: props.groupForm ?  \"\": \"none\", width: \"100%\", padding: \"0px 20px 20px\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.modalNaranjo"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-155"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormGroup",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-156"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormGroup",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 156,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 156,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 157,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "FormField",
      "parent": 157,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-161"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการแพ้ยา*",
          "valueEN": "Details of drug allergy*"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{color:\"red\"}"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-164"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", alignItems: \"Center\", width: \"100%\"}"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "TextArea",
      "parent": 163,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-TextArea-AdrFreeText"
        },
        "name": {
          "type": "value",
          "value": "note"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "rows": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.note"
        }
      },
      "seq": 165,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Button",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-SaveFreeText"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveNewADRNote"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\"}"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Button",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-CancelFreeText"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelNewADRNote"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 150,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-168"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"center\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 168,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flexDirection:\"column\", width: \"100%\", height: \"100%\", alignItems: \"center\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "div",
      "parent": 169,
      "props": {
        "children": {
          "type": "value",
          "value": "สำหรับเภสัชกร",
          "valueEN": "For pharmacists"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-170"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"10px\",display: props.showPharma}"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "div",
      "parent": 169,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-171"
        },
        "style": {
          "type": "code",
          "value": "{display: props.typePharma, flexDirection: \"column\", padding: \"10px\", backgroundColor: \"#e8f5fd\", borderRadius: \"5px\", height: \"170px\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-172"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-173"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-174"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-175"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-176"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 176,
      "props": {
        "children": {
          "type": "code",
          "value": "props.inactiveDate"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Radio",
      "parent": 172,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.pharmacyAction === \"NOTED\""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Radio-FreeTextNoted"
        },
        "label": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "NOTE"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "value": {
          "type": "value",
          "value": "NOTED"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "Radio",
      "parent": 173,
      "props": {
        "checked": {
          "type": "code",
          "value": "[\"VERIFIED\", \"PAUSED\"].includes(props.pharmacyAction)"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Radio-FreeTextVerify"
        },
        "label": {
          "type": "value",
          "value": "VERIFY (สั่งยาได้)",
          "valueEN": "VERIFY (prescription available)"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "value": {
          "type": "value",
          "value": "VERIFIED"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "Radio",
      "parent": 174,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.pharmacyAction === \"LOCKED\""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Radio-FreeTextLocked"
        },
        "label": {
          "type": "value",
          "value": "VERIFY & LOCK (ห้ามสั่งยา)",
          "valueEN": "VERIFY & LOCK (Do not order drugs)"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "value": {
          "type": "value",
          "value": "LOCKED"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Input",
      "parent": 95,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Input-NaranjoScore"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", padding: \"0 0.5rem\", opacity: \"1\",}"
        },
        "value": {
          "type": "code",
          "value": "props.AllergySequence.adrSelected?.naranjo_data?.score !== undefined ?  props.AllergySequence.adrSelected?.naranjo_data?.score : \"\""
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-184"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"100%\" }"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-185"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", marginRight: \"20px\", }"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-186"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\", marginLeft: \"20px\", }"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 185,
      "props": {
        "children": {
          "type": "value",
          "value": "--เลือกจากตัวยา--",
          "valueEN": "--Choose from the drug--"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-187"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px 10px\" }"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 186,
      "props": {
        "children": {
          "type": "value",
          "value": "--เลือกจากกลุ่มยา--",
          "valueEN": "--Select from drug group--"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-188"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 20px 10px\" }"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 186,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugGroupList"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(217, 217, 217, 0.46)\", overflowY: \"auto\", height: \"450px\", }"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 185,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ingredientList"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-190"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(217, 217, 217, 0.46)\", overflowY: \"auto\", height: \"450px\", }"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-191"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", alignItems: \"Center\", width: \"100%\", margin: \"20px 0px\", }"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "Button",
      "parent": 191,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-SaveCommonAdrNote"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveCommonADRNote"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "Button",
      "parent": 191,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Button-CancelCommonAdrNote"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelNewADRNote"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-194"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-195"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": null,
      "id": 196,
      "name": "div",
      "parent": 194,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่มีอาการ",
          "valueEN": "Date of symptom onset"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-196"
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 197,
      "name": "DateTextBox",
      "parent": 195,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-DateTextBox-SymptomsDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDateSymptoms"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.dateSymptoms"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 198,
      "name": "FormGroup",
      "parent": 50,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormGroup-198"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "FormField",
      "parent": 198,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-199"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "FormField",
      "parent": 198,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-FormField-200"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": null,
      "id": 201,
      "name": "div",
      "parent": 199,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบุอาการแพ้อื่นๆ",
          "valueEN": "Specify other allergic symptoms"
        },
        "className": {
          "type": "value",
          "value": "field-title"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-201"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 202,
      "name": "div",
      "parent": 200,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-div-202"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "Input",
      "parent": 202,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNote-Input-OtherSymptoms"
        },
        "name": {
          "type": "value",
          "value": "other_symptom"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeADR"
        },
        "value": {
          "type": "code",
          "value": "props.AllergySequence?.adrSelected?.other_symptom"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 205,
      "name": "Checkbox",
      "parent": 110,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.adrActive"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-Checkbox-205"
        },
        "label": {
          "type": "code",
          "value": "props.adrActive ? \"Active\" : \"INACTIVE\""
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 206,
      "name": "Checkbox",
      "parent": 175,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.adrActive"
        },
        "id": {
          "type": "value",
          "value": "CardAdverseReactionNoteUX-Checkbox-206"
        },
        "label": {
          "type": "code",
          "value": "props.adrActive ? \"Active\" : \"INACTIVE\""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePharmacyAction"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 206,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardAdverseReactionNoteUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 90
}

*********************************************************************************** */
